import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.DEFAULT,
    alt: 'college storage price page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'college storage price page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Affordable <span>College Storage</span><span>Prices Available</span>',
  description:
    'Find affordable college storage with clear pricing and flexible options, keeping you within budget while focusing on your education and campus life.',
  image: {
    url: '/images/v2/pages/landing-pages/college-storage-price/hero-image.jpg',
    alt: 'Reliable U-Box Container Storage Services'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Check College Storage Prices' }
}

export const ourProcessSectionContent = {
  title: 'How Our College Storage Price Works',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More About Pricing ' },

  image: {
    url: '/images/v2/pages/landing-pages/college-storage-price/how-our-college-storage-price-works.png',
    alt: 'How Our College Storage Price Works'
  },

  articles: [
    {
      id: 1,
      title: 'Transparent Pricing',
      description: 'We provide clear, upfront pricing with no hidden fees, so you always know what to expect.',
      image: {
        src: '/images/v2/pages/landing-pages/college-storage-price/transparent-pricing.png',
        alt: 'Transparent Pricing'
      }
    },
    {
      id: 2,
      title: 'Customizable Storage Plans',
      description:
        'Whether you need short-term or long-term storage, we offer flexible pricing that fits your specific needs.',
      image: {
        src: '/images/v2/pages/landing-pages/college-storage-price/customizable-storage-plans.png',
        alt: 'Customizable Storage Plans'
      }
    },
    {
      id: 3,
      title: 'Affordable Student Rates',
      description:
        'Our pricing plans are designed to be student-friendly, ensuring that college storage is both convenient and affordable.',
      image: {
        src: '/images/v2/pages/landing-pages/college-storage-price/affordable-student-rates.png',
        alt: 'Affordable Student Rates'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Secure College Storage Price Options',
  description:
    "ShipAndStorage offers high-quality college storage services with competitive prices. Our flexible storage plans make it easy to store your belongings safely and affordably. Whether you're in need of short-term or long-term solutions, we have you covered.",
  image: {
    src: '/images/v2/pages/landing-pages/college-storage-price/secure-college-storage-price-options.jpg',
    alt: 'Secure College Storage Price Options'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Affordable College Storage Price',

  cards: [
    {
      id: 1,
      title: 'Budget-Friendly Solutions',
      description:
        'Our storage prices are designed to fit within a student’s budget, making college storage both affordable and stress-free.',
      image: {
        src: '/images/v2/pages/landing-pages/college-storage-price/budget-friendly-solutions.png',
        alt: 'Budget-Friendly Solutions'
      }
    },
    {
      id: 2,
      title: 'Flexible Terms',
      description:
        'Choose the storage plan that works best for you, whether it’s for the summer, semester breaks, or the entire academic year.',
      image: {
        src: '/images/v2/pages/landing-pages/college-storage-price/flexible-terms.png',
        alt: 'Flexible Terms'
      }
    },
    {
      id: 3,
      title: 'Secure Storage',
      description:
        'Your belongings will be stored safely and securely, giving you peace of mind throughout your college years.',
      image: {
        src: '/images/v2/pages/landing-pages/college-storage-price/secure-storage.png',
        alt: 'Secure Storage'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Choose Our Affordable College Storage Price?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'First-Year Students',
          description:
            'Starting college and need a place to store your items? Our affordable rates make it easy to store your belongings securely while you focus on getting settled.'
        },
        {
          id: 2,
          title: 'Returning Students',
          description:
            'Looking for storage during breaks or while moving between apartments? We offer flexible pricing to accommodate your needs.'
        },
        {
          id: 3,
          title: 'Parents Helping Students',
          description:
            'Parents can rely on our affordable and secure storage solutions, knowing their child’s belongings are safe during their time at college.'
        },
        {
          id: 4,
          title: 'International Students',
          description:
            'For international students, our storage services are an ideal solution for keeping your items safe while you are away for the summer or during breaks.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/college-storage-price/who-should-choose-our-affordable-college-storage-price.jpg',
        alt: 'Who Should Choose Our Affordable College Storage Price?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Different Storage Services',

  cards: [
    {
      id: 1,
      title: 'Business Storage Solution',
      description: 'Need to store business items, documents, or inventory? We offer affordable and secure solutions.',
      image: {
        src: '/images/v2/pages/landing-pages/college-storage-price/business-storage-solution.png',
        alt: 'Business Storage Solution'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Business Storage' }
    },
    {
      id: 2,
      title: 'Moving Storage Solution',
      description:
        "Moving into a new home or apartment? Store your items conveniently and affordably until you're ready to move.",
      image: {
        src: '/images/v2/pages/landing-pages/college-storage-price/moving-storage-solution.png',
        alt: 'Moving Storage Solution'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Moving Storage' }
    },
    {
      id: 3,
      title: 'Luggage and Box Shipping Services',
      description: 'Ship your luggage and boxes quickly and affordably to any location, local or international.',
      image: {
        src: '/images/v2/pages/landing-pages/college-storage-price/luggage-and-box-shipping-services.png',
        alt: 'Luggage and Box Shipping Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Box Storage' }
    },
    {
      id: 4,
      title: 'Residential Storage Services',
      description: 'Ideal for homeowners who need extra storage during renovations or extended vacations.',
      image: {
        src: '/images/v2/pages/landing-pages/college-storage-price/residential-storage-services.png',
        alt: 'Residential Storage Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Residential Storage' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose ShipAndStorage for College Storage Price?',

  image: {
    url: '/images/v2/pages/landing-pages/college-storage-price/why-choose-shipandstorage-for-college-storage-price.jpg',
    alt: 'Why Choose ShipAndStorage for College Storage Price?'
  },

  articles: [
    {
      id: 1,
      title: 'Affordable Rates',
      description: 'We offer highly competitive pricing to make college storage accessible to all students.'
    },
    {
      id: 2,
      title: 'Flexible Storage Options',
      description: 'From short-term to long-term storage, we provide flexible plans that suit your needs.'
    },
    {
      id: 3,
      title: 'No Hidden Fees',
      description: 'Our pricing is transparent, so you won’t encounter unexpected costs along the way.'
    },
    {
      id: 4,
      title: 'On-Time Delivery',
      description: 'We ensure your belongings are delivered on time to your new dorm or apartment without delays.'
    },
    {
      id: 5,
      title: 'Secure and Reliable Storage',
      description:
        'With our secure facilities, your items will be safely stored and ready for pickup whenever you need them.'
    },
    {
      id: 6,
      title: 'Student-Centered Solutions',
      description:
        'Our services are designed to meet the needs of students, offering cost-effective and convenient storage options.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Affordable College Storage Prices Available Now',
  description:
    'Affordable college storage prices available. Fast and secure solutions for storing your belongings during the school year.',
  image: {
    src: '/images/v2/pages/landing-pages/college-storage-price/affordable-college-storage-prices-available-now.png',
    alt: 'Affordable College Storage Prices Available Now'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Get Started' }
}

export const ourPartnersSectionContent = {
  description:
    'ShipAndStorage works with top shipping carriers like FedEx, DHL, and UPS to offer high-quality storage and shipping solutions.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'Founded in 1971, FedEx handles millions of shipments globally with an extensive fleet and international reach.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy of the information provided. For more information, visit <a href='' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL is a leader in international logistics, managing billions of parcels annually with fast, reliable delivery services across 220+ countries.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS, one of the largest shipping companies in the world, provides reliable delivery services to over 220 countries and territories globally.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.ups.com/' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved"
      ]
    }
  ]
}
